import { render } from "./Accounts.vue?vue&type=template&id=3572dc33&scoped=true&ts=true"
import script from "./Accounts.vue?vue&type=script&lang=ts"
export * from "./Accounts.vue?vue&type=script&lang=ts"

import "./Accounts.vue?vue&type=style&index=0&id=3572dc33&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3572dc33"]])

export default __exports__